import { useEffect, useState } from 'react';

const useOnScreen = (ref, trigger, rootMargin = '0px 0px 0px 0px') => {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    if (typeof IntersectionObserver === 'undefined') {
      return;
    }

    let observedElement = null;
    let rafId = null;
    const observer = new IntersectionObserver(([entry]) => setIntersecting(entry.isIntersecting), {
      rootMargin: rootMargin,
    });

    const tryObserve = () => {
      const element = ref?.current;
      if (element instanceof Element) {
        observedElement = element;
        observer.observe(observedElement);
        return;
      }
      rafId = window.requestAnimationFrame(tryObserve);
    };

    tryObserve();
    return () => {
      if (rafId) {
        window.cancelAnimationFrame(rafId);
      }
      if (observedElement) {
        observer.unobserve(observedElement);
      }
      observer.disconnect();
    };
  }, [ref, trigger, rootMargin]);

  return isIntersecting;
};

export default useOnScreen;
